import getOr from 'lodash/fp/getOr';

export class SearchProduct {
  constructor(
    id,
    sku,
    checkoutPrice,
    checkoutCur,
    unitPrice,
    unitCur,
    site,
    meta,
    pid,
    detailUrl,
    slug,
  ) {
    this.id = id;
    this.sku = sku;
    this.checkoutPrice = checkoutPrice;
    this.checkoutCur = checkoutCur;
    this.unitPrice = unitPrice;
    this.unitCur = unitCur;
    /** @type {MetaSearchSite}*/
    this.site = site;
    /** @type {MetaSearchProduct}*/
    this.meta = meta;
    this.pid = pid;
    this.detailUrl = detailUrl;
    this.slug = slug;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      let unitPrice = 0, cur = "";
      if (typeof (input.unit_price) === "object") {
        unitPrice = getOr("", "unit_price.amount")(input);
        cur = getOr("", "unit_price.cur")(input);
      } else {
        unitPrice = input.unit_price;
        cur = input.cur;
      }
      return new SearchProduct(
        input.id,
        input.sku,
        getOr("", "checkout.amount")(input),
        getOr("", "checkout.cur")(input),
        unitPrice,
        cur,
        MetaSearchSite.fromApiObject(input.site),
        MetaSearchProduct.fromApiObject(input.meta),
        input.pid,
        input.detail_url,
        input.slug,
      )
    }

    return new SearchProduct();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SearchProduct.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SearchProduct.fromApiObject(input)];
    }

    return [];
  }

  getPId() {
    return this.pid || this.id;
  }
}

export class MetaSearchProduct {
  constructor(
    title,
    image,
    images,
    color,
    size,
    currentUrl,
    t,
    updatedAt,
    description
  ) {
    this.title = title;
    this.image = image;
    /** @type {[MetaSearchImages]}*/
    this.images = images;
    this.color = color;
    this.size = size;
    this.currentUrl = currentUrl;
    this.t = t;
    this.updatedAt = updatedAt;
    this.description = description;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new MetaSearchProduct(
        input.origin_title,
        input.image,
        MetaSearchImages.fromApiArray(input.images),
        input.color,
        input.size,
        input.current_url,
        input.t,
        input.unit_price_updated_at,
        input.description
      )
    }

    return new MetaSearchProduct();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => MetaSearchProduct.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [MetaSearchProduct.fromApiObject(input)];
    }

    return [];
  }
}

export class MetaSearchSite {
  constructor(
    id,
    domain,
    name,
    logo,
    country,
    currency
  ) {
    this.id = id;
    this.domain = domain;
    this.name = name;
    this.logo = logo;
    this.country = country;
    this.currency = currency;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new MetaSearchSite(
        input.id,
        input.domain,
        input.name,
        input.logo,
        input.country,
        input.currency,
      )
    }

    return new MetaSearchSite();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => MetaSearchSite.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [MetaSearchSite.fromApiObject(input)];
    }

    return [];
  }
}

export class MetaSearchImages {
  constructor(
    highRes,
    large,
    thumb,
  ) {
    this.highRes = highRes;
    this.large = large;
    this.thumb = thumb;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new MetaSearchImages(
        input.high_res,
        input.large,
        input.thumb,
      )
    }

    return new MetaSearchImages();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => MetaSearchImages.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [MetaSearchImages.fromApiObject(input)];
    }

    return [];
  }
}